import { render } from "./HomePageFive.vue?vue&type=template&id=927d4886"
import script from "./HomePageFive.vue?vue&type=script&lang=js"
export * from "./HomePageFive.vue?vue&type=script&lang=js"

import exportComponent from "E:\\量化\\my-websit-ai - 副本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__